import { createFileRoute } from "@tanstack/react-router";
import { FormulaTemplateEditor } from "@/features/kpi-admin/components/formula-template-editor";
import { z } from "zod";
import type { FormulaTemplateId } from "@brewbase/db/types";
import { RequireCapability } from "@/components/require-capability";

export const Route = createFileRoute(
  "/settings/formula-templates/$template_id",
)({
  component: () => (
    <RequireCapability cap="formula-template:edit">
      <RouteComponent />
    </RequireCapability>
  ),
  params: z.object({
    template_id: z.coerce
      .number()
      .transform((val) => val as FormulaTemplateId),
  }),
});

function RouteComponent() {
  const { template_id } = Route.useParams();

  return (
    <div className="container mx-auto px-4 pt-2 flex flex-col grow min-h-0">
      <FormulaTemplateEditor templateId={template_id} />
    </div>
  );
}
